import { useEffect } from "react";

import { useDispatch } from "@src/store";
import { setAiChat } from "@src/store/slices/global";

/**
 * Tells the Atlas rail — which lives outside the page tree — that the rule on
 * screen holds unsaved edits, so it withholds the minus that would hide it
 * (see `resolveAtlasRailCollapse`). Cleared when the page goes away.
 */
export const usePublishAtlasRuleEditing = (editing: boolean) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setAiChat({ key: "ruleEditing", value: editing }));
  }, [dispatch, editing]);
  useEffect(
    () => () => {
      dispatch(setAiChat({ key: "ruleEditing", value: false }));
    },
    [dispatch]
  );
};
